import React from "react";
import HomeComponent from "./HomeComponent";

const HomeEngine = ({ props }) => {

  return (
    <HomeComponent props={props} />
  );
};

export default HomeEngine;
